import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type {
  NotificationPreferenceChannel,
  NotificationPreferenceOverride,
  UserNotificationPreferencesResponse,
} from './getUserNotificationPreferences';
import { userNotificationPreferencesResponseSchema } from './getUserNotificationPreferences';

export interface UpdateUserNotificationPreferencesRequest {
  global?: {
    channels: NotificationPreferenceChannel[];
  };
  overrides?: NotificationPreferenceOverride[];
}

const updateUserNotificationPreferences: MutationFunction<
  UserNotificationPreferencesResponse,
  UpdateUserNotificationPreferencesRequest
> = async (args) => {
  if (isMockServices()) {
    return await mock({
      success: true,
      data: {
        global: {
          channels: ['EMAIL', 'IN_APP'],
          source: 'DEFAULT',
        },
        overrides: args.overrides ?? [],
      },
    });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const response = await authTokenHttp<UserNotificationPreferencesResponse>(
    `/users/me/notification-preferences`,
    {
      method: 'PUT',
      body: args,
    },
  );

  if (response.data) {
    return userNotificationPreferencesResponseSchema.parse(response.data);
  }

  throw new Error('Failed to update user notification preferences');
};

export default updateUserNotificationPreferences;
